import api from './axios';

export const companyBankAccountAPI = {
  /** GET /api/admin/company-bank-account */
  get: () => api.get('/admin/company-bank-account'),

  /** POST /api/admin/company-bank-account (multipart/form-data) */
  update: (formData) =>
    api.post('/admin/company-bank-account', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};
